import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-right', 'ArrowRight', [["path",{"d":"M5 12l14 0"}],["path",{"d":"M13 18l6 -6"}],["path",{"d":"M13 6l6 6"}]]);